import { createCRUDHook } from './createCRUDHook';
import { rmaDto } from 'utils/models';
import { RMA_ORDER } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<rmaDto>({
  entityName: 'RMA',
  endpoint: RMA_ORDER,
});

export const RMAContext = Context;
export const useRMAManager = useManager;
export const useRMA = useConsumer;
